import { actionEmitter, EmitEvent } from "../config/ActionEmitter";
import { CheckSiteNameCommand } from "../models/common/CheckSiteNameCommand";
import { IApiResponse, ICheckSiteResult, ISiteDetails } from "../models/Interfaces";
import { BaseService } from "./BaseService";

export class SiteService extends BaseService {

  public checkSiteName = async (sitename: string) : Promise<ICheckSiteResult | null> => {
    const url: string = `/Common/CheckSiteName`;
    const cmd = new CheckSiteNameCommand();
    cmd.SiteName = sitename;
    const res = await this._ajaxService.Post<IApiResponse>(url, cmd, false);
    
    if ((res?.StatusCode === 200 || res?.StatusCode === 409) && res.ReturnData) {
      return res.ReturnData;
    }
    return null;
  }

  public checkSubDomain = async (subdomain: string) : Promise<ICheckSiteResult | null> => {
    const url: string = `/Common/CheckSiteName`;
    const cmd = new CheckSiteNameCommand();
    cmd.SubDomain = subdomain;
    const res = await this._ajaxService.Post<IApiResponse>(url, cmd, false);
    
    if ((res?.StatusCode === 200 || res?.StatusCode === 409) && res.ReturnData) {
      return res.ReturnData;
    }
    return null;    
  }

  public checkDomain = async (domain: string) : Promise<ICheckSiteResult | null> => {
    const url: string = `/Common/CheckSiteName`;
    const cmd = new CheckSiteNameCommand();
    cmd.Domain = domain;
    const res = await this._ajaxService.Post<IApiResponse>(url, cmd, false);
    
    if ((res?.StatusCode === 200 || res?.StatusCode === 409) && res.ReturnData) {
      return res.ReturnData;
    }
    return null;    
  }

  public getSiteDetails = async () : Promise<ISiteDetails | null> => {
    if (this.siteKey) {
      const url: string = `/Site/GetSiteDetails/${this.siteKey}`;
      const res = await this._ajaxService.Get<IApiResponse>(url, true);
      
      if (res?.StatusCode === 200 && res.ReturnData) {
        return res.ReturnData;
      } else {
        this.EmitDataError(res, "Failed to retrieve site details");
      }
    }
    return null;
  }

  public saveSiteDetails = async (sitedetail: ISiteDetails) : Promise<ISiteDetails | null> => {
    if (this.siteKey) {
      const url: string = `/Site/AddUpdateSite`;
      sitedetail.SiteId = this.siteKey;
      const res = await this._ajaxService.Post<IApiResponse>(url, sitedetail, true);

      if (res?.StatusCode === 200 && res.ReturnData) {
        this.EmitDataSuccess(res.Messages?.[0] ?? "Site details updated");
        return res.ReturnData;
      } else {
        this.EmitDataError(res, "Failed to save site details");
      }
    }
    return null;
  }
}